// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"fa390253","766":"e88ca50f","845":"fe4e4579"}[chunkId] + ".chunk.js";
};